export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20abstract%20background%20with%20deep%20crimson%20and%20charcoal%20tones%2C%20dramatic%20lighting%2C%20subtle%20texture%20patterns%2C%20editorial%20news%20atmosphere%2C%20low%20key%20photography%20style%2C%20no%20text%2C%20no%20people%2C%20cinematic%20mood%2C%20professional%20dark%20aesthetic%20with%20warm%20undertones&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="黑料入口主题背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 pb-8 lg:pb-0">
            <p className="inline-block text-xs md:text-sm font-medium text-accent-400 bg-accent-500/10 border border-accent-500/20 px-3 py-1 rounded-full mb-5 whitespace-nowrap">
              黑料吃瓜网站 · 吃瓜黑料网站
            </p>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-50 leading-tight mb-4">
              黑料入口 · 你的黑料故事追踪站
            </h1>

            <p className="text-sm md:text-base text-primary-400 font-heading italic mb-6">
              后真相时代，我们为你还原黑料故事的真相脉络
            </p>

            <p className="text-sm md:text-base text-foreground-300 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-8">
              黑料入口汇集全网最新黑料事件、吃瓜前线动态与瓜田深度揭秘。从娱乐圈爆料到互联网内幕，从社会热点到财经暗流，我们以每日更新的节奏为你构建完整的黑料故事库，让你吃瓜吃得明明白白，追踪黑料后真相不停歇。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <p className="text-xl md:text-2xl font-bold text-accent-400 font-heading">2000+</p>
                <p className="text-xs text-foreground-500">黑料故事收录</p>
              </div>
              <div className="text-center">
                <p className="text-xl md:text-2xl font-bold text-accent-400 font-heading">每日更新</p>
                <p className="text-xs text-foreground-500">全天候追踪</p>
              </div>
              <div className="text-center">
                <p className="text-xl md:text-2xl font-bold text-accent-400 font-heading">12大</p>
                <p className="text-xs text-foreground-500">专题分类覆盖</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleScroll('#index')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-semibold text-sm rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                浏览专题合集
              </button>
              <button
                onClick={() => handleScroll('#ranking')}
                className="w-full sm:w-auto px-8 py-3 bg-background-200 hover:bg-background-300 text-foreground-200 font-medium text-sm rounded-md border border-background-300/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                查看热度榜单
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-lg overflow-hidden bg-background-200 border border-background-300/40">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20collage%20style%20image%2C%20dark%20mysterious%20atmosphere%2C%20newspaper%20clippings%20and%20digital%20screens%20aesthetic%2C%20warm%20crimson%20accents%20on%20dark%20background%2C%20investigative%20journalism%20vibe%2C%20no%20recognizable%20faces%2C%20abstract%20news%20media%20composition%2C%20professional%20dark%20mood&width=960&height=720&seq=hero-visual-01&orientation=landscape"
                alt="黑料入口 · 黑料故事追踪与揭秘平台"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}